var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"basic-header"},[_c('div',{staticClass:"header-inner"},[_c('a',{staticClass:"a-item"},[_c('a-icon',{attrs:{"type":"menu"},on:{"click":_vm.handleMenu}})],1),_c('a',{staticClass:"a-item"},[_c('a-icon',{attrs:{"type":"logout"},on:{"click":_vm.handleLogout}})],1)]),_c('MenuShowMobile',{ref:"menuShowMobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }